const Sidebar = () => import("@/components/layouts/Sidebar.vue");
const ClaimsOverviewPage = () => import('./components/claims/ClaimsOverviewPage.vue');
const ClaimEditPage = () => import('./components/claims/ClaimEditPage.vue');

export const claimRoutes = {
        path: "/claims",
        component: Sidebar,
        meta: {
            middleware: "auth",
            title: `Claims`,
            requiresAuth: true,
            permission: "claims.show",
        },
        children: [
            {
                name: "claims.index",
                path: "/claims/",
                component: ClaimsOverviewPage,
                meta: {
                    middleware: "auth",
                    title: `Claims`,
                    requiresAuth: true,
                    permission: "claims.show",
                },
            },
            {
                name: "claims.edit",
                path: "/claims/:id",
                component: ClaimEditPage,
                meta: {
                    middleware: "auth",
                    title: `Claim Edit`,
                    requiresAuth: true,
                    permission: "claims.edit",
                },
            },
        ]
};
